import { FEATURES } from '@/base/constants/authorization'

export const createSsoLoginAccessRule = {
  featureSet: {
    $elemMatch: {
      type: { $eq: FEATURES.SSO_LOGIN },
    },
  },
}
